import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyHotelBookingRoute = loadable(() => import(/* webpackChunkName: "content/guest/hotelbooking/routes/hotelbooking" */ './HotelBooking'), 'HotelBooking');
